import { Component } from '@angular/core';

import {
    GUIDE_AI_ADJUSTED_CONTENT,
    GUIDE_AI_ADJUSTED_TITLE,
    GUIDE_CANONICAL_FORMULA,
    GUIDE_CANONICAL_TITLE,
    GUIDE_EXPLAINABILITY_TITLE,
    GUIDE_EXPLAINABILITY_FORMULA,
    GUIDE_FEATURE_TABLE,
    GUIDE_INTRO_CONTENT,
    GUIDE_RISK_TREND_TABLE,
    GUIDE_RISK_TREND_NOTE_LINE2_PREFIX,
    GUIDE_RISK_TREND_TITLE,
    GUIDE_PAGE_TITLE,
    GUIDE_SCORING_REFERENCE_TEXT,
    GUIDE_SCORING_REFERENCE_TITLE,
    GuideStatusRow
} from './guide.constants';

@Component({
    selector: 'app-guide',
    templateUrl: './guide.component.html',
    styleUrls: ['./guide.component.scss'],
    standalone: false
})
export class GuideComponent {
    public readonly pageTitle = GUIDE_PAGE_TITLE;
    public readonly introContent = GUIDE_INTRO_CONTENT;
    public readonly scoringReferenceTitle = GUIDE_SCORING_REFERENCE_TITLE;
    public readonly scoringReferenceText = GUIDE_SCORING_REFERENCE_TEXT;
    public readonly canonicalTitle = GUIDE_CANONICAL_TITLE;
    public readonly explainabilityTitle = GUIDE_EXPLAINABILITY_TITLE;
    public readonly canonicalFormulaLines = GUIDE_CANONICAL_FORMULA;
    public readonly explainabilityFormulaLines = GUIDE_EXPLAINABILITY_FORMULA;
    public readonly featureTable = GUIDE_FEATURE_TABLE;
    public readonly riskTrendTable = GUIDE_RISK_TREND_TABLE;
    public readonly riskTrendTitle = GUIDE_RISK_TREND_TITLE;
    public readonly riskTrendNoteLine2Prefix = GUIDE_RISK_TREND_NOTE_LINE2_PREFIX;
    public readonly aiAdjustedTitle = GUIDE_AI_ADJUSTED_TITLE;
    public readonly aiAdjustedContentLines = GUIDE_AI_ADJUSTED_CONTENT;

    public getStatusClass(row: GuideStatusRow): string {
        return `status ${row.tone}`;
    }
}